(function(){
    /* Mehrfach-Laden abfangen (jede Section laedt das Script, soll aber nur 1x laufen) */
    if (window.__pshswInit) return;
    window.__pshswInit = true;

    function boot(){
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ===== Scroll-Reveal (alle .pshsw-Sections seitenweit) ===== */
      var reveals = document.querySelectorAll('.pshsw [data-reveal]:not([data-revealed])');
      if(!('IntersectionObserver' in window)){
        reveals.forEach(function(el){ el.classList.add('is-in'); el.setAttribute('data-revealed',''); });
      } else {
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
        reveals.forEach(function(el){ el.setAttribute('data-revealed',''); io.observe(el); });
      }

      /* ===== Modell-Tabs: Quick-Jump zur Karte + Scroll-Spy ===== */
      var track = document.getElementById('modelTrack');
      if(track && !track.__bound){
        track.__bound = true;
        var cards = Array.prototype.slice.call(track.querySelectorAll('.card'));
        var tabsWrap = document.getElementById('modelTabs');
        var tabEls = tabsWrap ? Array.prototype.slice.call(tabsWrap.querySelectorAll('.modelTab')) : [];

        function setActiveTab(i){
          tabEls.forEach(function(t, idx){
            var on = idx === i;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        }

        tabEls.forEach(function(tab, i){
          tab.addEventListener('click', function(){
            var target = cards[i];
            if(target){
              try{ target.scrollIntoView({block:'center', behavior: reduce ? 'auto' : 'smooth'}); }
              catch(e){ target.scrollIntoView(); }
            }
            setActiveTab(i);
          });
        });

        if('IntersectionObserver' in window && tabEls.length){
          var spy = new IntersectionObserver(function(entries){
            entries.forEach(function(e){
              if(e.isIntersecting){
                var idx = cards.indexOf(e.target);
                if(idx > -1) setActiveTab(idx);
              }
            });
          }, {threshold:0.55});
          cards.forEach(function(c){ spy.observe(c); });
        }
      }

      /* ===== Vergleichstabelle: rechten Fade-Hinweis ausblenden, wenn ausgescrollt ===== */
      document.querySelectorAll('.pshsw .cmpWrap').forEach(function(wrap){
        if(wrap.__cmpBound) return; wrap.__cmpBound = true;
        var sc = wrap.querySelector('.cmpScroll');
        if(!sc) return;
        var tick = false;
        function update(){
          var atEnd = sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4;
          wrap.classList.toggle('is-end', atEnd);
        }
        sc.addEventListener('scroll', function(){
          if(tick) return; tick = true;
          requestAnimationFrame(function(){ update(); tick = false; });
        }, {passive:true});
        update();
      });

      /* ===== Modell-Tabs als untere Sticky-Bar (Mobil): ab dem ersten Modell
         einblenden, ausblenden sobald man die Modelle nach oben verlassen hat ===== */
      var tabsBar = document.querySelector('.pshsw .modelTabsWrap');
      var modelsSec = document.getElementById('modelle');
      var trackEl = document.getElementById('modelTrack');
      if(tabsBar && modelsSec && !tabsBar.__stickyBound){
        tabsBar.__stickyBound = true;
        var tabsTick = false;

        /* Pandectes Cookie-Reopen-Button finden (auch in offenen Shadow-Roots),
           damit er beim Einblenden der Bar mit hochgeschoben wird. */
        var consentBtn = null;
        var CONSENT_SEL = 'button.widget.bottom, .widget.bottom.shadow-dialog, button[aria-haspopup="dialog"].widget';
        function findConsent(){
          if(consentBtn && document.contains(consentBtn)) return;
          var b = document.querySelector(CONSENT_SEL);
          if(!b){
            var all = document.querySelectorAll('*');
            for(var i=0;i<all.length;i++){
              var sr = all[i].shadowRoot;
              if(sr){ var h = sr.querySelector(CONSENT_SEL); if(h){ b = h; break; } }
            }
          }
          if(b){ consentBtn = b; applyConsentShift(); }
        }
        function applyConsentShift(){
          if(!consentBtn) return;
          var mobile = window.matchMedia('(max-width: 767px)').matches;
          var on = tabsBar.classList.contains('is-stuck');
          if(mobile && on){
            var h = (tabsBar.offsetHeight || 64) + 14;
            consentBtn.style.transition = 'transform .32s cubic-bezier(.23,1,.32,1)';
            consentBtn.style.transform = 'translateY(-' + h + 'px)';
          } else {
            consentBtn.style.transform = '';
          }
        }
        findConsent();
        [400, 1200, 2500, 5000].forEach(function(t){ setTimeout(findConsent, t); });

        function checkTabsBar(){
          var r = modelsSec.getBoundingClientRect();
          var firstCard = trackEl && trackEl.querySelector('.card');
          // ab dem ersten Modell: oberer Rand der ersten Karte ist in den Viewport gescrollt
          var started = firstCard
            ? firstCard.getBoundingClientRect().top < (window.innerHeight - 60)
            : (r.top < window.innerHeight * 0.6);
          // verlassen: Modelle sind nach oben rausgescrollt
          var ended = r.bottom < 100;
          var on = started && !ended;
          tabsBar.classList.toggle('is-stuck', on);
          applyConsentShift();
        }
        window.addEventListener('scroll', function(){
          if(tabsTick) return; tabsTick = true;
          requestAnimationFrame(function(){ checkTabsBar(); tabsTick = false; });
        }, {passive:true});
        window.addEventListener('resize', checkTabsBar, {passive:true});
        checkTabsBar();
      }
    }

    if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();
